import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LoupeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"loupe"}/>
}
